import memoize from "../../../utils/memoize";

export const rotatingWheelSizeInPercentage = 89;

export const getScaledSize = memoize((size: number, percentage: number) => {
    return size * percentage / 100;
});